export enum InputPasswordReactMode {
    iprmInsert = 1, // utilizado na inserção (sempre tem a senha + confirmação)
    iprmEdit = 2, // utilizado na edição (sempre tem a senha e confirmação, mas não haverá obrigatoriamente uma alteração)
    iprmEnterPassword = 3 // não aparece o campo de confirmação de senha, e somente a senha é digitada
}
